import {
  SET_CONFIG,
  MERGE_CONFIG
} from '../mutation-type'
// import config from 'src/config/init'

// initial state
const state = {
  notices: true,
  inlineErrors: false,
  history: true,
  loadingAnimation: true,
  debug: false
}

// mutations
const mutations = {
  [SET_CONFIG] (state, config) {
    //
  },

  [MERGE_CONFIG] (state, config) {
    Object.assign(state, config)
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/config.js